'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import clsx from 'clsx';
import { TabsProps } from './types';
const Tabs = t0 => {
  const $ = _c(10);
  const {
    items,
    defaultIndex
  } = t0;
  const t1 = defaultIndex || 0;
  let t2;
  if ($[0] !== items) {
    t2 = items.length > 1 && <TabList className="z-20 mb-14 flex gap-1 rounded-full bg-white p-1 md:mb-20">{items.map(_temp)}</TabList>;
    $[0] = items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp2);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <TabPanels className="z-20 w-full" data-sentry-element="TabPanels" data-sentry-source-file="index.tsx">{t3}</TabPanels>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <TabGroup defaultIndex={t1} className="flex flex-col items-center overflow-hidden" data-sentry-element="TabGroup" data-sentry-component="Tabs" data-sentry-source-file="index.tsx">{t2}{t4}</TabGroup>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default Tabs;
function _temp(t0) {
  const {
    name
  } = t0;
  return <Tab key={name} className={clsx("data-selected:bg-primary-600 w-22.5 rounded-full py-2 outline-hidden transition-all duration-300 data-selected:outline-hidden", "text-button font-medium text-gray-600")}>{name}</Tab>;
}
function _temp2(t0) {
  const {
    name: name_0,
    Content
  } = t0;
  return <TabPanel key={name_0}>{Content}</TabPanel>;
}